import React, { useState } from 'react'
import { Link } from 'gatsby'

import Search from './search'
import { colors, media } from '../theme'
import logoSvg from '../assets/logo-white.svg'
import iconSvg from '../assets/icon-white.svg'
import { FiGitlab } from 'react-icons/fi'
import { FaHistory, FaBlog } from 'react-icons/fa'
import { MdQueuePlayNext } from 'react-icons/md'

import {
  Button,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'

const MyNavbarBrand = () => (
  <Link to="/">
    <picture css={{ margin: `3px auto`, height: `36px` }}>
      <source
        media={`(min-width: ${media.min(`small`)}px)`}
        srcSet={logoSvg}
        css={{ height: `36px` }}
      />
      <img src={iconSvg} alt="logo lyceum.fr" css={{ height: `36px` }} />
    </picture>
  </Link>
)

// TODO: gérer l'activation ici
const MyNavLink = ({ to, color = `primary`, isActive, children }) => (
  <Link to={to}>
    <Button color={color} active={isActive}>
      {children}
    </Button>
  </Link>
)

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)
  return (
    <div>
      <Navbar color="primary" dark expand="md">
        <NavbarBrand tag={MyNavbarBrand} />
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink
                href="https://framagit.org/lyceum"
                title="Code source sur framagit.org"
              >
                <FiGitlab size={26} />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://archives.lyceum.fr"
                title="Archives des années précédentes"
              >
                <FaHistory size={26} />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://h5p.lyceum.fr"
                title="Exercices interactifs sur h5p.lyceum.fr"
              >
                <MdQueuePlayNext size={26} />
              </NavLink>
            </NavItem>
            <NavItem>
              <Link to="/blog/" title="Le blog du site" className="nav-link">
                <FaBlog size={26} />
              </Link>
            </NavItem>
            <NavItem>
              <MyNavLink
                to="/2gt/snt/"
                color={colors.classes[`2gt`]}
                isActive={props.pathname.includes(`/2gt/`) ? true : false}
              >
                SNT 2<sup>de</sup>
              </MyNavLink>
            </NavItem>
            <NavItem>
              <MyNavLink
                to="/1g/nsi"
                color={colors.classes[`1g`]}
                isActive={props.pathname.includes(`/1g/`) ? true : false}
              >
                NSI 1<sup>ère</sup>
              </MyNavLink>
            </NavItem>
            <NavItem>
              <MyNavLink
                to="/tg/nsi"
                color={colors.classes[`tg`]}
                isActive={props.pathname.includes(`/tg/`) ? true : false}
              >
                NSI T<sup>le</sup>
              </MyNavLink>
            </NavItem>
            <Search data={props.data} />
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  )
}

export default Header
